import dayjs from "@/lib/dayjs";
/**
 * 日本語の年月日に変換する
 * @param date
 * @returns
 */
export function convertToJapaneseYearMonthDay(date: string) {
	return dayjs(date).format("YYYY年MM月DD日");
}
